import React from 'react'
import { Cell } from 'rsuite-table'
import './TaskStatusCount.scss'

type RowData = {
  [key: string]: number
}

type TaskStatusCountCellProps = {
  rowData?: RowData,
  dataKey: string
}

const COUNT_STATUS_MAP: Record<string, string> = {
  totalPendingFile: 'pending',
  totalCompletedFile: 'completed',
  totalUntrainedFile: 'untrained-document',
  totalFailedFile: 'failed'
}

const TaskStatusCountCell: React.FC<TaskStatusCountCellProps> = ({
  rowData,
  dataKey,
  ...props
}) => {
  const count = rowData?.[dataKey] as number | undefined
  const classSuffix = COUNT_STATUS_MAP[dataKey] ?? ''
  return (
    <Cell style={{ paddingLeft: '15%' }} {...props}>
      <span className={`task-status-badge task-status-${classSuffix}`}>
        {count ?? 0}
      </span>
    </Cell>
  )
}

export default TaskStatusCountCell
